import { ERROR_MSGS, CONSTANTS } from '../../utils'
import { store } from '../../store'
import { alertActions } from '../../store/actions'

const useInternetConnectionHandler = (online) => {
	store.dispatch(alertActions.NO_INTERNET_CONNECTION(online))
	!online &&
		store.dispatch(
			alertActions.warning(ERROR_MSGS.EN.NETWORK_ERROR, CONSTANTS.ERROR_TYPE.TOAST, false)
		)
	online && store.dispatch(alertActions.clear())
}

export default useInternetConnectionHandler
